export default "__VITE_ASSET__CTiGDrC9__";